// extracted by mini-css-extract-plugin
export default {"mediaQueryMobile":"810","mediaQueryTablet":"1024","mediaQueryDesktop":"1440"};